import { gql } from '@apollo/client';

export const marketingEmailsOptedInQuery = gql`
  query marketingEmailsOptedIn {
    currentUser {
      id
      marketingEmailsOptedIn
    }
  }
`;

export const setMarketingEmailsOptedInMutation = gql`
  mutation ECOMMERCE_setMarketingEmailsOptedIn($marketingEmailsOptedIn: Boolean!) {
    setMarketingEmailsOptedIn(marketingEmailsOptedIn: $marketingEmailsOptedIn) {
      id
      marketingEmailsOptedIn
    }
  }
`;
